"use client";

import posthog from "posthog-js";

let isPostHogInitialized = false;

export function initPostHog() {
  const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

  if (!token || isPostHogInitialized) return posthog;

  posthog.init(token, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
    capture_pageview: "history_change",
    defaults: "2026-01-30",
    loaded: (posthogClient) => {
      if (process.env.NODE_ENV === "development") {
        posthogClient.debug();
      }
    },
  });

  isPostHogInitialized = true;

  return posthog;
}

export { posthog };
